export class DialogModelTicketInstructions {
    constructor(
        public instructions: any
    ) { }
}